import { TradingOfferOperationsContextType } from '../types/TradingOfferOperationsContextType';

export const tradingOfferOperationsInitValue: TradingOfferOperationsContextType =
  {
    data: {
      totalTradingOfferOperations: 0,
      tradingOfferOperations: [],
      selectedTradingOfferOption: null,
      tradingOfferOptions: [],
      statusOptions: [],
      tradingOfferTypeOptions: [],
      isPartnerView: false,
      partnerId: '',
      page: 0,
      rowsPerPage: 10,
      isAdmin: false,
      isReadOnly: false,
      isLoading: true,
    },
    actions: {
      handleChangeTradingOfferOption: () => {},
      handleSearchTradingOffer: async () => [],
      handleChangeStatusOption: () => {},
      handleChangeTradingOfferTypeOption: () => {},
      handleChangePage: () => {},
      handleChangeRowsPerPage: () => {},
      handleViewTradingOfferOperation: () => {},
      handleEditTradingOfferOperationStatus: () => {},
    },
  };
